import { jsonIf } from '../utils/utils.network';

export const fetchQuestions = async ({ yearId, makeId, modelId, trimId, colorId, transmissionId, engineId, drivetrainId, vin = '', mileage }) => {
  const body = JSON.stringify({
    vehicle: {
      yearId,
      makeId,
      modelId,
      trimId,
      colorId,
      transmissionId,
      engineId,
      drivetrainId,
      vin,
    },
    mileage,
    contactInfo: {},
    isConsumerOffer: true,
    channelId: process.env.CHANNEL_ID,
    vehicleBuildDataFlags: {
      cadsUsed: false,
      transmissionsVinVerified: false,
      enginesVinVerified: false,
      drivetrainsVinVerified: false,
      optionsVinVerified: false,
      colorsVinVerified: false,
    },
  });

  const maxRetries = 3;
  let attempt = 0;
  while (attempt < maxRetries) {
    try {
      const response = await fetch(`${process.env.BASE_URL}/${process.env.V_PREFIX}/documents?api_key=${process.env.API_KEY}`, {
        method: 'POST',
        headers: {
          authorization: `Basic ${process.env.ICO_TOKEN}`,
          QuestionConversion: 'fury',
        },
        body,
        redirect: 'follow',
        mode: 'cors',
      });
      const result = await jsonIf(response);
      // DE565093 - Retry if no data or code is 400021 - VIN decode error
      if (!result?.data || result?.meta?.codes.includes(400021)) {
        attempt++;
        await new Promise((resolve) => setTimeout(resolve, 500)); // wait 0.5s before retry
        continue;
      }
      return {
        questionsGroupedByCanonical: result.data.documents,
        answers: result.data.wipReadback?.answers,
        trimInformation: result.data.trimInformation,
        vehicleInformationResponse: result.data.vehicleInformationResponse,
        documentsApiFailed: false,
      };
    } catch (error) {
      console.log('error', error);
      attempt++;
    }
  }
  // If all retries fail, return object empty to prevent the crashing app
  return {
    questionsGroupedByCanonical: [],
    answers: [],
    trimInformation: {},
    vehicleInformationResponse: {},
    documentsApiFailed: true,
  };
};

export default { fetchQuestions };
